import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { CLEARGY, PROMODETAILLPAGE } from "common/viewContent";
import Helmet from "react-helmet";
import * as Path from "routes/Path/index";
import Table from "components/Table";
import Columns from "./Columns";
import BackButtom from "components/BackButtom";
import { Col, Row } from "react-bootstrap";
import { useMeetingHistory, userHistoryList } from "store/actions";
import MeetingHistory from "components/MeetingHistory";
import { getDoctorListFiltered } from "store/actions";

const PriestDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [data, setData] = useState();
  const [activeTab, setActiveTab] = useState("login");
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  const [nextPage, setNextPage] = useState(1);
  const [filter, setFilter] = useState({
    pageNo: currentPage,
    limit: pageSize,
  });
  const [newFilter, setNewFilter] = useState({
    pageNo: nextPage,
    limit: pageSize,
  });
  const [selected, setSelected] = useState("multi-user");
  const [submittedValue, setSubmittedValue] = useState("");
  const [isFiltered, setisFiltered] = useState(true);
  const [filtereddoctorsData, setfiltereddoctorsData] = useState([]);
  const [count, setcount] = useState();
  const toggleTab = (tab) => {
    setActiveTab(tab);
  };
  useEffect(() => {
    fetchData(filter);
    handleSubmit(selected);
  }, []);
  const fetchData = (filter) => {
    setLoading(true);
    const payload = {
      ...filter,
      page: filter?.pageNo,
      record_count: filter?.limit,
      user_id: id,
    };
    try {
      const callback = (err, res) => {
        if (err) {
          console.log(err);
          setLoading(false);
        } else {
          setData(res);
          setLoading(false);
        }
      };
      dispatch(userHistoryList({ data: payload, callback }));
    } catch (error) {
      console.log(error);
    }
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleChange = (e) => {
    setSelected(e.target.value);
    handleSubmit(e.target.value);
  };

  useEffect(() => {
    handleSubmit(selected);
  }, [newFilter]);

  const handleSubmit = (selected) => {
    console.log("id", id);
    setLoading(true);
    setfiltereddoctorsData([]);

    // e.preventDefault(); // prevent page reload
    const payloadData = {
      page: newFilter.pageNo,
      record_count: 20,
      user_id: id,
      userType: "2",
      meetingType: selected, //would be like ("single-mic", "multi-user", "single-user")
    };
    const callback = (err, res) => {
      if (err) {
        toast.error(err);
      } else {
        // setDoctor(res);
        console.log("resqwxxsa121doctor!", res);
        // console.log('USER',USER);
        // dispatch(updateUserLocally(res?.meeting_data)); // Update local Redux state
        const users = res?.meeting_data.map((item) => {
          return {
            recordid: item?.id,
            meeting_id:
              item?.meeting_information?.[0]?.meeting_id || item?.meeting_id,
            appointment_date: item?.appointment_date,
            appointment_time: item?.appointment_time,
            status: item?.appointment_status,
            ...(item?.user ||
              item?.patient_information ||
              item?.doctor_information),
          };
        });
        console.log("userssss222sdoctor!", users);
        setcount(res?.total_record_count);
        setfiltereddoctorsData(users);
        setisFiltered(true);
      }
      setLoading(false);
    };
    dispatch(getDoctorListFiltered({ data: payloadData, callback }));
  };
  console.log(state, "some_state");
  return (
    <>
      {(data === "true" || loading) && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={CLEARGY.CURRENT_MODULE} />
      <section className="section">
        <div className="section-header">
          <BackButtom />
          <h1>{CLEARGY.CURRENT_MODULE}</h1>
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.clergy}>Clergy</Link>
            </div>
            <div className="breadcrumb-item">{CLEARGY.CURRENT_MODULE}</div>
          </div>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">{CLEARGY.TOP_CONTENT}</h2>
                </div>
              </div>
            </div>
          </div>
          <Row className="px-4 justify-content-center ">
            <Col className=" col-md-12 my-2 h-100 w-100 card rounded-lg">
              <div className="d-flex justify-content-center border-bottom">
                <h6 className=" p-2 ">Clergy Details</h6>
              </div>
              <div className="d-flex ">
                <div className="col-md-6 my-2 h-100 w-100">
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Priest Name</p>
                    <span className="py-1">{state?.row?.full_name}</span>
                  </div>
                  <div className="d-flex justify-content-between gap-2  border-bottom">
                    <p className="fw-bolder">Email</p>
                    <span className="py-1">{state?.row?.email}</span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Organization Name</p>
                    <span className="py-1">
                      {state?.row?.organization_name
                        ? state?.row?.organization_name
                        : "---"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Bio</p>
                    <span className="py-1">
                      {state?.row?.bio ? state?.row?.bio : "---"}
                    </span>
                  </div>
                  {/* <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Doctor Code </p>
                    <span className="py-1">{state?.row?.doctor_code}</span>
                  </div> */}
                  {/* <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Patient Code</p>
                    <span className="py-1">{state?.row?.patient_code}</span>
                  </div> */}
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Age</p>
                    <span className="py-1">
                      {state?.row?.age ? state?.row?.age : "---"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">License No</p>
                    <span className="py-1">{state?.row?.license_no}</span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Referral Type</p>
                    <span className="py-1">
                      {state?.row?.referType ? state?.row?.referType : "---"}
                    </span>
                  </div>
                </div>
                <div className="col-md-6 my-2 h-100 w-100 ">
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Country Name</p>
                    <span className="py-1">
                      {state?.row?.country ? state?.row?.country : "---"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between gap-2  border-bottom">
                    <p className="fw-bolder">State</p>
                    <span className="py-1">
                      {state?.row?.state ? state?.row?.state : "---"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">City </p>
                    <span className="py-1">
                      {state?.row?.city ? state?.row?.city : "---"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Verification Document</p>
                    <span className="py-1">
                      {state?.row?.verification_document
                        ? state?.row?.verification_document
                        : "---"}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Country Code</p>
                    <span className="py-1">{state?.row?.country_code}</span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Phone No</p>
                    <span className="py-1">{state?.row?.phone_no}</span>
                  </div>
                  <div className="d-flex justify-content-between  border-bottom">
                    <p className="fw-bolder">Address</p>
                    <span className="py-1">
                      {state?.row?.address ? state?.row?.address : "---"}
                    </span>
                  </div>
                  {state?.row?.referType === "Referral" && (
                    <div className="d-flex justify-content-between  border-bottom">
                      <p className="fw-bolder">Referrer Name</p>
                      <span className="py-1">{state?.row?.referName}</span>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-12">
                <ul className="nav nav-tabs pillsTab">
                  <li className="nav-item">
                    <button
                      className={`nav-link d-flex align-items-center justify-content-center ${
                        activeTab === "login" ? "active" : ""
                      }`}
                      onClick={() => toggleTab("login")}
                    >
                      Login History
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link d-flex align-items-center justify-content-center ${
                        activeTab === "meeting" ? "active" : ""
                      }`}
                      onClick={() => toggleTab("meeting")}
                    >
                      Meeting History
                    </button>
                  </li>
                </ul>
                {activeTab === "meeting" && (
                  <div style={{ padding: "20px" }}>
                    <form
                      onSubmit={handleSubmit}
                      style={{
                        // background: "#f9f9f9",
                        // padding: "24px",
                        // borderRadius: "12px",
                        // maxWidth: "400px",
                        // boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                        fontFamily: "'Segoe UI', sans-serif",
                        // margin: "40px auto",
                      }}
                    >
                      <label
                        style={{
                          display: "block",
                          marginBottom: "10px",
                          fontWeight: "bold",
                          fontSize: "18px",
                        }}
                      >
                        Select a method:
                      </label>
                      <select
                        value={selected}
                        onChange={handleChange}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          borderRadius: "8px",
                          border: "1px solid #ccc",
                          fontSize: "16px",
                          marginBottom: "20px",
                        }}
                      >
                        <option value="single-mic">Single Mic</option>
                        <option value="multi-user">Multi User</option>
                        <option value="single-user">Single User</option>
                      </select>
                    </form>

                    {submittedValue && (
                      <p style={{ marginTop: "20px" }}>
                        ✅ You submitted: <strong>{submittedValue}</strong>
                      </p>
                    )}
                  </div>
                )}
                <div className="tab-content align-items-center">
                  {activeTab === "login" && (
                    <div className="tab-pane fade show active ">
                      <div className="card">
                        <div className="topHead px-3 ">
                          <h6 className="m-0 fw-bold py-2">Login History</h6>
                        </div>
                        {loading && (
                          <div className="main-loader">
                            <FadeLoader size={1000} />
                          </div>
                        )}
                        {!loading &&
                          (data?.users?.length > 0 ? (
                            <div className="tab-pane fade show active">
                              <Table
                                data={data?.users}
                                columns={Columns({ data })}
                                setFilter={setFilter}
                                totalCount={data?.total_record_count}
                                handleTableChange={handlePageChange}
                                filter={filter}
                              />
                            </div>
                          ) : (
                            !loading && (
                              <p style={{ textAlign: "center" }}>
                                No data Found
                              </p>
                            )
                          ))}
                      </div>
                    </div>
                  )}
                  {activeTab === "meeting" && (
                    <div className="tab-pane fade show active">
                      <div className="card">
                        <div className="topHead px-3 ">
                          <h6 className="m-0 fw-bold py-2">Meeting History</h6>
                        </div>
                        <MeetingHistory
                          user_id={id}
                          userType={"2"}
                          isFiltered={isFiltered}
                          filtereddoctorsData={filtereddoctorsData}
                          selected={selected}
                          count={count}
                          setNextPage={setNextPage}
                          setNewFilter={setNewFilter}
                          newFilter={newFilter}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default PriestDetails;
